import { useContext } from 'react';
import GlobalContext from '../../contexts/index';
import CreateTerapist from '../Terapists/componenets/create';
import TerapistPage from '../Terapists/componenets/view';
import TerapistsList from '../Terapists/componenets/list';
import CreateCustomer from '../Customers/componenets/create';
import CustomersList from '../Customers/componenets/list';
import CustomerPage from '../Customers/componenets/view';
import OrganizationsList from '../Organiztions/components/list';
import AddOrganization from '../Organiztions/components/create';
import OrganizationPage from '../Organiztions/components/view';
import UsersList from '../Users/componenets/list';
import { useParams } from 'react-router-dom';
import AddUser from '../Users/componenets/create';
import UserPage from '../Users/componenets/view';
import ProductsList from '../Products/components/list';
import CreateProduct from '../Products/components/create';
import ProductPage from '../Products/components/view';
import BloodTestForm from '../BloodTestForm/components/list';
// import LabTesting from '../LabTesting';
import LabsList from '../Labs/components/list';
import NotificationsList from '../Notifications/components/list';
import NotificationPage from '../Notifications/components/view';
import MeasuresPage from '../Customers/componenets/Measures';
import BloodParamPage from 'components/BloodTestForm/components/view';
import CreateBloodparam from 'components/BloodTestForm/components/create';
import GeneTestForm from 'components/GeneTestForm/components/list';
import GeneParamPage from 'components/GeneTestForm/components/view';
import CreateGeneparam from 'components/GeneTestForm/components/create';
import TerapistMeetings from 'components/Terapists/componenets/meetings';
import { filter } from 'lodash';
import { useNavigate } from 'react-router-dom';
import './style.scss';
import ReportPage from 'components/Report/components/list';
import CreateReportField from 'components/Report/components/create';
import EditReportField from 'components/Report/components/view';
import ClientCyclePage from '../Reports/ClientCyclePage';
import SurveyTest from 'components/SurveyLab';
import SurveyMeasurePage from 'components/SurveyLab/components/edit';
import GeneticClientsMissingDetails from 'components/Reports/GeneticCLientsMissingDetails';
import EditSurveyText from 'components/SurveyLab/TextsList/edit';
import SurveySummeryTexts from 'components/SurveyLab/TextsList';
import SurveyWaitingDoctor from 'components/Reports/SurveyWaitingDoctor';
import PredibetesWaitingDoctor from 'components/Reports/PredibetesWaitingDoctor';
import PredibetesOrgDashboard from 'components/Reports/predibetesOrgDashboard';
import MedicalInfo from 'components/Customers/componenets/medicalInfo';
import AnalysisBloodTests from 'components/Reports/analysisBloodTests';
import AnalysisGeneticTests from 'components/Reports/analysisGenticTests';
import AnalysisQuestions from 'components/Reports/analysisQuestions';
import AnalysisMeetings from 'components/Reports/analysisMeetings';
import PrediabetesTest from 'components/PrediabetesLab';
import PrediabetesMeasurePage from 'components/PrediabetesLab/components/edit';
import PredibetesWaitingSummery from 'components/Reports/PredibetesWaitingSummery';

const PageContent = () => {
  const { link, menuData, currentUser } = useContext(GlobalContext);
  const { entity, id, idd } = useParams();
  const navigate = useNavigate();
  if (!entity) {
    const firstEntity = menuData?.[0]?.link?.key;
    if (firstEntity) navigate(`/${firstEntity}`);
  }

  const renderSwitch = () => {
    const entityRule = filter(menuData, { link: { key: entity } });
    if (!(entityRule?.[0]?.link?.rules?.indexOf(currentUser?.role?.name) > -1))
      return 'not allowd';
    else
      switch (entity) {
        case 'meetings':
          return <TerapistMeetings />;
        case 'therapists':
          if (link) return <CreateTerapist />;
          if (id) return <TerapistPage />;
          return <TerapistsList />;
        case 'clients':
          if (link) {
            if (link === 'medicalInfo') return <MedicalInfo />;
            if (link === 'measures') return <MeasuresPage />;
            else return <CreateCustomer />;
          }
          if (id) return <CustomerPage />;
          else return <CustomersList />;
        case 'organizations':
          if (link) return <AddOrganization />;
          if (id) return <OrganizationPage />;
          return <OrganizationsList />;
        case 'products':
          if (link) return <CreateProduct />;
          if (id) return <ProductPage />;
          return <ProductsList />;
        case 'users':
          if (link) return <AddUser />;
          if (id) return <UserPage />;
          return <UsersList />;

        case 'notifications':
          if (idd) return <NotificationPage />;
          if (id === 'genetic') return <NotificationsList />;
          else if (id === 'survey') return <NotificationsList />;
          return;
        case 'labs':
          if (id) {
            if (id === 'blood') {
              if (link) return <CreateBloodparam />;
              if (idd) return <BloodParamPage></BloodParamPage>;
              else return <BloodTestForm />;
            } else if (id === 'gene') {
              if (link) return <CreateGeneparam />;
              if (idd) return <GeneParamPage></GeneParamPage>;
              else return <GeneTestForm />;
            } else if (id === 'report') {
              if (link) return <CreateReportField />;
              if (idd) return <EditReportField />;
              else return <ReportPage />;
            }
          }
          return <LabsList />;
        case 'survey':
          if (id) {
            if (id === 'texts') {
              if (idd) return <EditSurveyText></EditSurveyText>;
              return <SurveySummeryTexts />;
            }
            // if (link) return <CreateBloodparam />;
            if (idd) return <SurveyMeasurePage></SurveyMeasurePage>;
            else return <SurveyTest />;
          }
          return <SurveyTest />;
        case 'pre-diabetes':
          if (id) {
            // if (id === 'texts') {
            //   if (idd) return <EditSurveyText></EditSurveyText>;
            //   return <SurveySummeryTexts />;
            // }
            if (idd) return <PrediabetesMeasurePage></PrediabetesMeasurePage>;

            return <PrediabetesTest />;
          }
          break;
        case 'reports':
          if (id) {
            if (id === 'cycle') return <ClientCyclePage />;
            if (id === 'genetic') return <GeneticClientsMissingDetails />;
            if (id === 'analysisBloodTests') return <AnalysisBloodTests />;
            if (id === 'analysisGeneticTests') return <AnalysisGeneticTests />;
            if (id === 'analysisQuestions') return <AnalysisQuestions />;
            if (id === 'analysisMeetings') return <AnalysisMeetings />;
          }
          break;
        case 'reportsPreDiabetes':
          if (id) {
            if (id === 'waitingDoctor') return <PredibetesWaitingDoctor />;
            if (id === 'waitingGeneralSummery')
              return <PredibetesWaitingSummery />;
            if (id === 'orgDashboard') return <PredibetesOrgDashboard />;
          }
          break;

        case 'reportsSurvey':
          if (id) {
            if (id === 'surveyWaitingDoctor') return <SurveyWaitingDoctor />;
          }
          break;

        default:
          return '';
      }
  };
  return <div className="page-content">{renderSwitch()}</div>;
};

export default PageContent;
